import { toZonedTime } from './zoned-time';

type EventBoundary = { dateTime?: string | null; date?: string | null };

type ZonedEvent = {
  start: EventBoundary;
  end: EventBoundary;
};

// All-day boundaries are already floating dates — only a timed boundary carries an instant to move.
const toZonedBoundary = <B extends EventBoundary>(
  boundary: B,
  timeZone: string,
): B => {
  if (!boundary.dateTime) {
    return boundary;
  }

  return {
    ...boundary,
    dateTime: toZonedTime(new Date(boundary.dateTime), timeZone).toISOString(),
  };
};

export const toZonedEventTimes = <T extends ZonedEvent>(
  event: T,
  timeZone: string,
): T => ({
  ...event,
  start: toZonedBoundary(event.start, timeZone),
  end: toZonedBoundary(event.end, timeZone),
});
